import React, { useEffect, useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import config from '../functions/config';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const ManageUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(`${config.BASE_URL}/api/manage-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      } else {
        console.error("Failed to fetch users");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleAction = async (userId, action) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(`http://:8000/api/manage-users/${userId}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ action }),
      });

      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        fetchUsers(); // Refresh the user list
      } else {
        alert(data.error || "An error occurred.");
      }
    } catch (error) {
      console.error("Error handling action:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
   




<div>
{/* Navbar */}
<nav className="navbar navbar-expand-lg navbar-light fixed-top">
<a className="navbar-brand text-light" href="#">
Admin 
</a>
<button
className="navbar-toggler bg-light"
type="button"
data-bs-toggle="collapse"
data-bs-target="#navbarSupportedContent"
aria-controls="navbarSupportedContent"
aria-expanded="false"
aria-label="Toggle navigation"
>
<span className="navbar-toggler-icon"></span>
</button>
<div className="collapse navbar-collapse" id="navbarSupportedContent">
<ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
<li className="nav-item">
  <a className="nav-link text-light" href="#dashboard">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faTachometerAlt} />
    </span>
    <span className="nav-text">Dashboard</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="#add-agent">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBook} />
    </span>
    <span className="nav-text">Register Book</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="#our-agents">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faUsers} />
    </span>
    <span className="nav-text">Manage User</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="#campaign">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faListCheck} />
    </span>
    <span className="nav-text">Manage Book</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="#campaign">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faCartShopping} />
    </span>
    <span className="nav-text">Purchase History</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="#campaign">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBagShopping} />
    </span>
    <span className="nav-text">Rental History</span>
  </a>
</li>
</ul>
<ul className="navbar-nav ml-auto pr-5">
<li className="nav-item mr-5">
  <a className="nav-link text-light fixed-right" href="#logout">
    <FontAwesomeIcon icon={faRightFromBracket} /> Logout
  </a>
</li>
</ul>
</div>
</nav>

{/* Book Registration Form */}
<div className="container content px-5 mt-5 pt-2 ">
      <h2>Manage Users</h2>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Username</th>
            <th>Email</th>
            <th>Status</th>
            <th>Date Joined</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>{user.is_active ? "Active" : "Inactive"}</td>
              <td>{new Date(user.date_joined).toLocaleDateString()}</td>
              <td>
                <button
                  className="btn btn-success btn-sm me-2"
                  onClick={() => handleAction(user.id, "approve")}
                  disabled={user.is_active || loading}
                >
                  Approve
                </button>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => handleAction(user.id, "disapprove")}
                  disabled={!user.is_active || loading}
                >
                  Disapprove
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleAction(user.id, "delete")}
                  disabled={loading}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

<style jsx>{`


  .content {
    margin-left: 200px;
  }
  @media (max-width: 768px) {
    .vertical-nav {
      width: 100%;
    }
    .content {
      margin-left: 0;
    }
  }
.navbar {
background: #1a1a1a; /* Dark background color */
}

.vertical-nav {
background: #1a1a1a; /* Dark background color */
position: fixed;
top: 56px;
left: 0;
height: calc(100% - 56px);
overflow-y: auto;
padding-top: 30px;
z-index: 999;
}

.vertical-nav .nav-link {
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
padding: 10px 15px;
color: #ff6700; /* Dark orange font color */
transition: background-color 0.3s; /* Smooth hover effect */
}

.vertical-nav .nav-link:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}

.nav-icon {
font-size: 20px;
margin-right: 10px;
color: #ff6700; /* Dark orange for icons */
}

li {
border-bottom: 2px solid black;
}

li:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}


.btn {
width: 100%; /* Full-width button */
background-color: #ff6700; /* Dark orange background for button */
color: white;
border: none;
padding: 10px;
font-size: 16px;
font-weight: bold;
border-radius: 5px;
}

.btn:hover {
background-color: #e65c00; /* Darker orange on hover */
cursor: pointer;
}

body {
position: relative;
margin: 0; /* Remove default margins */
padding: 0; /* Remove default padding */
}

body::before {
content: '';
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
background-size: cover; /* Ensure the image covers the entire body */
opacity: 0.4; /* Apply opacity only to the image */
z-index: -1; /* Place it behind all other content */
}

a {
text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
font-family: "Times New Roman", Times, serif; /* Classic font */
color: #1a1a1a; /* Match the theme color */
}
`}</style>
</div>
  );
};

export default ManageUsersPage;
